<div *ngIf="loading" class="loading">Loading map...</div>

<highcharts-chart
  *ngIf="!loading"
  [Highcharts]="Highcharts"
  [constructorType]="'mapChart'"
  [options]="chartOptions"
  style="width: 100%; height: 600px; display: block;"
></highcharts-chart>
